import { EMOTES } from './custom.js';
import { customEmotesPattern } from './custom-regex.js';
const CUSTOM_EMOTE_PATTERN = customEmotesPattern();
export function renderEmotes(baseUrl, el) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const texts = [];
    while (walker.nextNode())
        texts.push(walker.currentNode);
    for (const node of texts) {
        const str = node.nodeValue ?? '';
        const parts = str.split(CUSTOM_EMOTE_PATTERN);
        if (parts.length === 1)
            continue;
        let modified = false;
        const frag = document.createDocumentFragment();
        for (const part of parts) {
            if (!part)
                continue;
            const em = EMOTES.find((e) => e.shortcodes?.includes(part));
            if (em) {
                const img = document.createElement('img');
                img.className = 'emote';
                img.alt = (em.shortcodes && em.shortcodes[0]) || em.name;
                img.title = part;
                img.loading = 'lazy';
                img.decoding = 'async';
                img.src = baseUrl + em.url;
                img.ariaLabel = em.name;
                img.height = em.height;
                img.width = em.width;
                frag.append(img);
                modified = true;
            }
            else {
                frag.append(part);
            }
        }
        if (modified)
            node.replaceWith(frag);
    }
}
//# sourceMappingURL=emote.js.map